/* ndl-gallery-lightbox.js — click-to-enlarge for the native gallery.
 *
 * Binds to the theme's OWN PhotoSwipe (window.FoxTheme.PhotoSwipe*), the same one
 * main-product.liquid uses. Deliberately not a second lightbox library: two would
 * mean two sets of styles, two keyboard handlers and twice the weight, for one
 * behaviour the theme already implements.
 *
 * Degrades honestly: if PhotoSwipe is missing for any reason, clicking simply does
 * nothing rather than throwing — and the setting that turns this on is only
 * rendered when the assets are loaded, so it cannot advertise a feature that is
 * not there. (It did exactly that before this file existed: "Click to enlarge"
 * defaulted ON and was wired to nothing.)
 */
(function () {
  'use strict';

  function open(section, startIndex) {
    var FT = window.FoxTheme;
    if (!FT || !FT.PhotoSwipeLightbox || !FT.PhotoSwipe) return;

    var figs = section.querySelectorAll('.ndl-gallery__item img[data-full]');
    var dataSource = [];
    figs.forEach(function (img) {
      dataSource.push({
        src: img.getAttribute('data-full'),
        width: parseInt(img.getAttribute('data-full-w'), 10) || 1800,
        height: parseInt(img.getAttribute('data-full-h'), 10) || 1200,
        alt: img.getAttribute('alt') || ''
      });
    });
    if (!dataSource.length) return;

    var lb = new FT.PhotoSwipeLightbox({
      dataSource: dataSource,
      pswpModule: FT.PhotoSwipe,
      bgOpacity: 1,
      counter: true,
      preloader: false
    });
    lb.init();
    lb.loadAndOpen(startIndex || 0);
  }

  // Delegated, because a gallery section can be added or reordered in the theme
  // editor after load without a page refresh.
  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('.ndl-gallery__item img[data-full]');
    if (!img) return;
    var section = img.closest('.ndl-gallery');
    if (!section || section.getAttribute('data-lightbox') !== 'true') return;
    // A tile wrapped in a link should follow the link, not open the lightbox —
    // the editor set that link on purpose.
    if (img.closest('a')) return;
    e.preventDefault();
    var all = Array.prototype.slice.call(
      section.querySelectorAll('.ndl-gallery__item img[data-full]'));
    open(section, all.indexOf(img));
  });
})();
